import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDynamicComponent as _resolveDynamicComponent, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_message_wrap = _resolveComponent("message-wrap")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.message.text)
      ? (_openBlock(), _createBlock(_component_message_wrap, {
          key: 0,
          isShowMessageTail: _ctx.isShowMessageTail,
          message: _ctx.message,
          avatar: _ctx.avatar,
          class: "q-mb-sm"
        }, null, 8, ["isShowMessageTail", "message", "avatar"]))
      : _createCommentVNode("", true),
    (_ctx.isLastMessage)
      ? (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.questionType), {
          key: 1,
          buttons: _ctx.message.buttons,
          message: _ctx.message,
          respondentId: _ctx.respondentId,
          onClickButtonWithPayload: _cache[0] || (_cache[0] = (payload) => _ctx.$emit('send-message', payload)),
          onInit: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('init')))
        }, null, 40, ["buttons", "message", "respondentId"]))
      : _createCommentVNode("", true)
  ]))
}